/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react';

import { getMatchingGrayColor } from 'solis/theme/palette';


const getTransform = ({ hexGeometry, zoneData, ...props }) =>
{
  const { x, y } = hexGeometry.getPointFromHex(zoneData.getDisplayHex());

  return `translate(${x}px, ${y}px)`;
}


const Center = styled.g`
  transform: ${props => getTransform(props)};

  opacity: ${({ dimmed }) => dimmed ? 0.5 : 1};
  filter: ${({ dimmed }) => dimmed ? 'blur(1px)' : 'none'};
`;


// - zoneData
// - hexGeometry
export default ({ children, ...props }) =>
{
  const color = props.zoneData.getColor();

  return <Center {...props} data-accent-color = {color} data-gray-color = {getMatchingGrayColor(color)}> {children} </Center>;
}
